import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getControlSheetAdvance } from "../../redux/actions/controlSheet.action"
import { getDefaultCompany } from "../../redux/actions/defaultCompany";
import { getAllCompany } from "../../redux/actions/companyAccess";
import PageHeader from "../../components/PageHeader/PageHeader";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { sendEmail, sendOrderConfirmationAutoApprovedPTEmail, sendOrderConfirmationEmail, sendOrderPaymentDuePTEmail } from "../../redux/actions/email.action";
import { TabTitle } from "../../utils/GeneralFunction";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { ReadCookie } from "../../utils/readCookie";
import { FilterFilled, MailOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, notification, Table } from "antd";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import numeral from "numeral";
import moment from "moment";
import "./pickticket.css";

const ControlSheetAdvanceship = () => {
    const [minimize, setMinimize] = useState(false);
    const menuId = ReadCookie("menuId");
    const token = ReadCookie("token");
    const dispatch = useDispatch();
    TabTitle("Control-Sheet-Advanceship")
    const [selectedRows, setSelectedRows] = useState([]);
    const [controlSheet, setControlSheet] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loadings, setLoadings] = useState([]);
    const tableRef = useRef(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    // const onSelectChange = (newSelectedRowKeys, selectedRows) => {

    //     setSelectedRows(selectedRows)
    //     setSelectedRowKeys(newSelectedRowKeys);
    // };
    // const rowSelection = {
    //     selectedRowKeys,
    //     onChange: onSelectChange,
    // };
    useEffect(() => {
        dispatch(getAllCompany(token));
        dispatch(getDefaultCompany(token));
        dispatch(getControlSheetAdvance(token)).then((res) => {
            setLoading(false);
            setSpinner(false);
            setControlSheet(res?.payload?.data);
        });
    }, [dispatch, menuId, token]);


    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: 'PT #',
            dataIndex: 'ship_header_no',
            key: 'ship_header_no',
            width: 70,
            render: (text, record) => (
                <Link style={{ color: "#0d6efd", textDecoration: "underline" }}
                    to={"/order-shipment?mode=edit&order_id=" + record.ship_header_id + "&customer_id/" + record.customer_id + "?edit=yes"}
                >
                    {text}
                </Link>
            ),
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.ship_header_no.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.ship_header_no - b.ship_header_no;
              },
        },
        {
            title: 'PT Date',
            render: (text, record) => {
                return <>{moment(record.ship_date).format("MM-DD-YYYY")}</>;
            },
            width: 90,
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.ship_date.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.ship_date - b.ship_date;
              },
        },
        {
            title: 'Invoice Date',
            render: (text, record) => {
                return <>{moment(record.invoice_date).format("MM-DD-YYYY")}</>;
            },
            width: 90,
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.invoice_date.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.invoice_date - b.invoice_date;
              },
        },
        {
            title: 'Start Date',
            render: (text, record) => {
                return <>{moment(record.start_date).format("MM-DD-YYYY")}</>;
            },
            width: 90,

            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.start_date.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.start_date - b.start_date;
              },
        },
        {
            title: 'Cancel Date',
            render: (text, record) => {
                return <>{moment(record.cancel_date).format("MM-DD-YYYY")}</>;
            },
            width: 90,

            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.cancel_date.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.cancel_date - b.cancel_date;
              },
        },
        {
            title: 'Due Date',
            render: (_, record) => {
                const dueDate = moment(record.invoice_date).add(record.days_until_net_due, 'days').startOf('day');
                return dueDate.format('MM-DD-YYYY');
            },
            width: 90,
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.invoice_date.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.invoice_date - b.invoice_date;
              },
        },
        {
            title: 'Days Remaining',
            dataIndex: 'days_remaining',
            render: (_, record) => {
                const dueDate = moment(record.invoice_date)
                    .add(record.days_until_net_due, 'days')
                    .startOf('day');
                const today = moment().startOf('day');
                const diff = dueDate.diff(today, 'days');
                if (diff > 0) {
                    return `Due in ${diff} days`;
                } else if (diff === 0) {
                    return "Due today";
                } else {
                    return (
                        <span style={{ color: 'red' }}>
                            {`${Math.abs(diff)} days Overdue`}
                        </span>
                    );
                }
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.days_remaining.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.days_remaining - b.days_remaining;
              },
        },
        {
            title: 'Customer',
            dataIndex: 'addressee',
            key: 'addressee',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.addressee.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.addressee - b.addressee;
              },
            // width: 200
        },
        {
            title: 'SO #',
            dataIndex: 'order_header_no',
            key: 'order_header_no',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.order_header_no.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.order_header_no - b.order_header_no;
              },
            // width: 80
        },
        {
            title: 'PO #',
            dataIndex: 'reference_no',
            key: 'reference_no',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.reference_no.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.reference_no - b.reference_no;
              },
            // width: 120
        },
        {
            title: 'Qty',
            render: (text, record) => {
                return <>{parseFloat(record.quantity).toFixed(0)}</>;
            },
            // width: 60,
            align: "right",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.quantity.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.quantity - b.quantity;
              },
        },
        {
            title: 'Amount',
            render: (text, record) => {
                return <>$ {numeral(record.gross_amount).format("0,00")}</>
            },
            // width: 80,
            align: "right",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.gross_amount.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.gross_amount - b.gross_amount;
              },
        },
        {
            title: 'Discount Amount',
            render: (text, record) => {
                return <>$ {numeral(record.discount_amount).format("0,00")}</>
            },
            // width: 120,
            align: "right",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.discount_amount.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.discount_amount - b.discount_amount;
              },
        },
        {
            title: 'Freight',
            render: (text, record) => {
                return <>$ {numeral(record.shipping_cost).format("0,00")}</>
            },
            // width: 80,
            align: "right",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.shipping_cost.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.shipping_cost - b.shipping_cost;
              },
        },
        {
            title: 'Surcharge Amount',
            render: (text, record) => {
                return <>$ {numeral(record.surcharge_amount).format("0,00")}</>
            },
            // width: 120,
            align: "right",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.surcharge_amount.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.surcharge_amount - b.surcharge_amount;
              },
        },
        {
            title: 'Net Amount',
            render: (text, record) => {
                return <>$ {numeral(record.net_amount).format("0,00")}</>
            },
            // width: 100,
            align: "right",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.net_amount.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.net_amount - b.net_amount;
              },
        },
        {
            title: 'Term',
            dataIndex: 'term_name',
            key: 'term_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.term_name.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.term_name - b.term_name;
              },
            // width: 100
        },
        {
            title: 'Sale Person',
            dataIndex: 'salesperson_name',
            key: 'salesperson_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.salesperson_name.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.salesperson_name - b.salesperson_name;
              },
            // width: 200
        },
        {
            title: 'Region',
            dataIndex: 'region_name',
            key: 'region_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.region_name.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.region_name - b.region_name;
              },
            // width: 200
        },
        {
            title: 'PT Status',
            dataIndex: 'pt_status_name',
            key: 'pt_status_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.pt_status_name.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.pt_status_name - b.pt_status_name;
              },
            // width: 160
        },
        {
            title: 'Shipped Status',
            dataIndex: 'ship_status_name',
            key: 'ship_status_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.ship_status_name.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.ship_status_name - b.ship_status_name;
              },
            // width: 160
        },
        {
            title: 'Approved',
            dataIndex: 'is_approved',
            key: 'is_approved',
            render: (text, record) => {
                return <>{record.is_approved ? "Yes" : "No"}</>
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.is_approved.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.is_approved - b.is_approved;
              },
            // width: 80
        },
        {
            title: 'Customer Email',
            dataIndex: 'email',
            key: 'email',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.email.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.email - b.email;
              },
            // width: 200
        },
        {
            title: 'Customer Phone',
            dataIndex: 'phone',
            key: 'phone',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.phone.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.phone - b.phone;
              },
            // width: 120
        },
        {
            title: 'Comment',
            dataIndex: 'cs_comment',
            key: 'cs_comment',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.cs_comment.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.cs_comment - b.cs_comment;
              },
            // width: 220
        },
        {
            title: '# of Emails Sent',
            dataIndex: 'pt_count',
            key: 'pt_count',
            render: (text, record, index) => {
                return text ? text : 0
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => {
                return (
                  <>
                    <Input
                      allowClear
                      autoFocus
                      className="pop-search-gen pop-170"
                      placeholder="Type text here"
                      value={selectedKeys[0]}
                      onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                      }}
                      onPressEnter={() => {
                        confirm();
                      }}
                      onBlur={() => {
                        confirm();
                      }}
                    />
                  </>
                );
              },
              filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
              onFilter: (value, record) =>
                record.pt_count.toString().toLowerCase().includes(value.toLowerCase()),
              sorter: (a, b) => {
                return a.pt_count - b.pt_count;
              },
        },
        {
            title: 'Send Email',
            render: (text, record, index) => {
                const dueDate = moment(record.invoice_date)
                    .add(record.days_until_net_due, 'days')
                    .startOf('day');
                const today = moment().startOf('day');
                const diff = dueDate.diff(today, 'days'); // yehi days remaining nikalega

                return (
                    <Button
                        icon={<MailOutlined />}
                        loading={loadings[index]}
                        disabled={diff < 0} // agar overdue hai toh disable
                        onClick={() => sendingEmail(record, index)}
                    >
                        Send Email
                    </Button>
                );
            },
        },
    ];

    // const sendToAll = (() => {
    //     setSpinner(true)
    //     selectedRows?.map((res) => {
    //         if (res.email) {
    //             // Approved
    //             dispatch(sendOrderPaymentDuePTEmail(token, res)).then((res) => {
    //                 if (res.type === "SEND_EMAIL_SUCCESS") {
    //                     setSelectedRowKeys([]);
    //                     setSelectedRows([]);
    //                     setSpinner(false)
    //                     notification.success({
    //                         message: "Success",
    //                         description: res?.payload,
    //                     });
    //                 }
    //             });
    //         }
    //         else {
    //             Swal.fire({
    //                 icon: "error",
    //                 title: "Oops...",
    //                 text: "Customer Email is required!"
    //             });
    //         }
    //     })
    // })

    function sendingEmail(e, index) {
        setLoadings((prevLoadings) => {
            const newLoadings = [...prevLoadings];
            newLoadings[index] = true;
            return newLoadings;
        });

        const data = {
            ship_date: e.ship_date,
            invoice_date: e.invoice_date,
            cancel_date: e.cancel_date,
            addressee: e.addressee,
            order_header_no: e.order_header_no,
            reference_no: e.reference_no,
            quantity: e.quantity,
            gross_amount: e.gross_amount,
            net_amount: e.net_amount,
            surcharge_amount: e.surcharge_amount,
            term_name: e.term_name,
            salesperson_name: e.salesperson_name,
            salesperson_email: e.salesperson_email,
            region_name: e.region_name,
            pt_status_name: e.pt_status_name,
            is_approved: e.is_approved,
            phone: e.phone,
            is_email: true,
            customer_id: e.customer_id,
            email: e.email,
            cs_comment: e.cs_comment,
            ship_header_id: e.ship_header_id,
            ship_header_no: e.ship_header_no,
            shipping_cost: e.shipping_cost,
            secondary_email: e.secondary_email,
            days_until_net_due: e.days_until_net_due,
            start_date: e.start_date
        }
        if (e.email) {
            // Approved
            dispatch(sendOrderPaymentDuePTEmail(token, data)).then((res) => {
                if (res.type === "SEND_EMAIL_SUCCESS") {
                    console.log("REs", res)
                    setLoadings((prevLoadings) => {
                        const newLoadings = [...prevLoadings];
                        newLoadings[index] = false;
                        return newLoadings;
                    });
                    notification.success({
                        message: "Success",
                        description: res?.payload,
                    });
                }
            });
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Customer Email is required!"
            });
            setLoadings((prevLoadings) => {
                const newLoadings = [...prevLoadings];
                newLoadings[index] = false;
                return newLoadings;
            });
        }
    }

    return (
        <div className="styleContainer">
            <div className="styleBody h-100">
                <PageHeader
                    title={"Control Sheet Advanceship"}
                    minimize={setMinimize}
                    check={minimize}
                />
            </div>
            <div style={{ marginTop: 10 }}>
                <Table
                    title={() =>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <DownloadTableExcel
                                filename={`Control-Sheet-Advanceship-${moment().format("MM-DD-YYYY")}`}
                                sheet="Control Sheet"
                                currentTableRef={tableRef.current}
                            >
                                <span
                                    className="print_icon printing_class">
                                    <input
                                        style={{ height: "30px", width: "30px" }}
                                        size={"large"}
                                        type="image"
                                        name="ImgExcel"
                                        alt="Export to excel"
                                        id="ImgExcel"
                                        title="Export to excel"
                                        src={xlsx}
                                    />
                                </span>
                            </DownloadTableExcel>
                            {/* {selectedRows.length ?
                                <Button onClick={() => sendToAll()}>
                                    Selected {selectedRows.length} Items
                                </Button> : ""
                            } */}
                        </div>
                    }
                    // rowSelection={{ ...rowSelection }}
                    // rowKey={(record) => record.ship_header_id}
                    ref={tableRef}
                    size="small"
                    bordered={false}
                    type="company"
                    // scroll={{ x: 'calc(1200px + 100%)', y: 700 }}
                    scroll={{
                        x: 'max-content',
                        // y: 450,
                    }}
                    pagination={{ pageSize: 1000 }}
                    dataSource={controlSheet}
                    columns={columns}
                    loading={spinner}
                    paginate
                    rowClassName={(record) => record.is_email ? "odd" : ''}


                />
            </div>
        </div>
    )
}

export default ControlSheetAdvanceship;